import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

@Component({
  selector: 'app-basic-line-chart',
  templateUrl: './basic-line-chart.component.html',
  styleUrls: ['./basic-line-chart.component.scss']
})
export class BasicLineChartComponent implements OnInit {

  @Input() series: any[];
  @Input() xlabel: string;
  @Input() ylabel: string;

  @Input() percent: boolean;
  @Input() width: string = '100%';
  @Input() height: string = '300px';

  showLegend: boolean = true;
  showGraph: boolean = true;

  chart: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;
  chartXLabel: string;

  labelToType = { // Default type is 'line'
    risky_part: 'area',
    cushion: 'area',
  }

  labelToFillColor = {
    risky_part: 'rgba(145,187,225,0.7)',
    cushion: 'rgba(40,106,172,0.7)',
  }

  labelToColor: any = {
    original: 'rgba(227,143,72,0.75)',
    benchmark: 'rgba(205,205,205,0.75)',
    investable: 'rgba(129,186,241,0.75)',
    protected: 'rgba(94,187,75,1)',

    default1: 'rgba(40,106,172,0.75)',
    default2: 'rgba(145,187,225,0.75)',
    default3: 'rgba(180,209,236,0.75)',

    floor: 'rgb(150,150,150)',
    risky_part: 'rgb(145,187,225)',
    cushion: 'rgb(40,106,172)',
  };
  labelToName: any = {
    original: 'Original',
    benchmark: 'Benchmark',
    investable: 'Investable',
    protected: 'Protected',

    floor: 'Floor',
    risky_part: 'Risky Part',
    cushion: 'Cushion',
  };

  seriesLabelToName: any = {...this.labelToName};

  constructor() { }

  ngOnInit(): void {
    this.percent = this.percent!=undefined;

    this.series.forEach((data) => {
      if (('label' in data) && ('name' in data)) {
        this.seriesLabelToName[data['label']] = data['name'];
      }
    });

    let thisComponent = this;
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let months_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    this.chartOptions = {
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      navigation: {
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },
      chart: {
          type: 'line',
          zoomType: 'xy',
          backgroundColor: 'rgba(255,255,255,0)',
          resetZoomButton: {
            position: {
              align: 'left',
              verticalAlign: 'top'
            }
          }
      },
      xAxis: {
          type: 'datetime',
          title: {
              text: this.xlabel
          }
      },
      yAxis: {
          title: {
              text: this.ylabel
          },
          min: 0,
          gridLineDashStyle: "Dash",
          gridLineColor: 'rgba(100,100,100,1)',
          labels: {
            formatter: function () {
              return ((thisComponent.percent?100:1)*this.value).toFixed(1) + (thisComponent.percent?' %':'');
            }
          }
      },
      tooltip: {
        formatter: function () {
          const date = new Date();
          date.setTime(this.point.x);
          return '<b>' + this.series.name + '</b><br>' +
                  months[date.getMonth()]+' '+date.getDate()+', '+date.getFullYear()+ ': ' +
                  ((thisComponent.percent?100:1)*this.y).toFixed(2) + (thisComponent.percent?' %':'');
        },
        useHTML: true
      },

      plotOptions: {
          series: {
              marker: {
                  enabled: false
              },
              lineWidth: 1.5
          }
      },

      // Define the data points. All series have a dummy year
      // of 1970/71 in order to be compared on the same x axis. Note
      // that in JavaScript, months start at 0 for January, 1 for February etc.
      series: this.series.filter(series=>series.historical_values).map(
        (data) => {
          let size = data.historical_values.length;
          return {
            name: this.seriesLabelToName[data.label],
            data: data.historical_values.filter(
              // TODO: improve this filter that keeps only 1/5th of points + first and last date
              (date_value, index) => {
                return index%5==0 || index==0 || index==(size-1);
              }
            ).map(
              (date_value) => {
                return [new Date(date_value[0]).getTime(), date_value[1]]
              }
            ),
            color: this.labelToColor[data.label],
            fillColor: this.labelToFillColor[data.label] ? this.labelToFillColor[data.label] : undefined,
            type: this.labelToType[data.label] ? this.labelToType[data.label] : 'line',
          }
        }
      ),

      responsive: {
          rules: [{
              condition: {
                  maxWidth: 500
              },
              chartOptions: {
                  plotOptions: {
                      series: {
                          marker: {
                              radius: 2.5
                          }
                      }
                  }
              }
          }]
      },
      legend: {
        enabled: this.showLegend,
        itemStyle: {
          color:'grey'
        }
      }
    };

    HC_exporting(Highcharts);

  }

}
